import React, { createContext } from 'react';

import type { ActiveTheme } from '../types';

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export const ThemeBoundaryContext: React.Context<ActiveTheme> = createContext<ActiveTheme>({});
